<template>
  <div class="team-user">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList(1)">
      <el-form-item label="团队">
        <el-input v-model="dataForm.teamName"></el-input>
      </el-form-item>
      <el-form-item label="店铺">
        <el-select v-model="dataForm.storeId" placeholder="请选择">
          <el-option
            v-for="item in storeList"
            :key="item.storeId"
            :label="item.storeName"
            :value="item.storeId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="区域">
        <el-select v-model="dataForm.districtId" placeholder="请选择" @change="selectItme">
          <el-option
            v-for="item in areaList"
            :key="item.districtId"
            :label="item.districtName"
            :value="item.districtId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getDataList(1)">查询</el-button>
        <el-button @click="cleaList()">重置</el-button>
      </el-form-item>
    </el-form>

    <el-button type="primary" class="addBtn" @click="addOrUpdateHandle()">新建团队</el-button>

    <el-table :data="dataList" border v-loading="dataListLoading" style="width: 100%;" :header-cell-style="{background: '#eef1f6', color: '#606266', fontSize: '14px'}">
      <el-table-column prop="teamName" align="center" min-width="150" label="团队名称"></el-table-column>
      <el-table-column prop="realName" align="center" min-width="120" label="组长">
        <template slot-scope="scope">
          {{getLeader(scope.row)}}
        </template>
      </el-table-column>
      <el-table-column prop="users" align="center" min-width="250" label="组员">
        <template slot-scope="scope">
          <span style="margin-right:5px;" v-for="item in scope.row.users" :key="item.userId">{{item.realName}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="storeName" align="center" min-width="180" label="所属店铺"></el-table-column>
      <el-table-column prop="districtName" align="center" min-width="180" label="所属区域"></el-table-column>
      <el-table-column align="center" min-width="150" label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row.teamId)">编辑</el-button>
          <!-- <el-button type="text" size="small" @click="deleteHandle(scope.row.teamId)">删除</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper"
    ></el-pagination>
    <!-- 弹窗, 新增 / 修改 -->
    <team-edit v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList" :areaList="areaList" :storeList="storeList"></team-edit>
  </div>
</template>

<script>
import teamEdit from "./comm/teamEdit";
import { teamList } from './api'
import { districtList, storeListData } from '@/api/list' //公共请求接口
export default {
  components: {
    teamEdit,
  },
  data() {
    return {
      dataForm: {
        storeId: "",
        teamName: "",
        realName: "",
        districtName: "",
      },
      dataList: [{}],
      storeList: [],
      areaList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false,
    };
  },
  mounted() {
    this.getDataList();
    this.getStore();
    this.getArea();
  },
  methods: {
    // 获取团队列表
    getDataList(page) {
      this.dataListLoading = true;
      teamList({
        page: page ||this.pageIndex,
        limit: this.pageSize,
        teamName: this.dataForm.teamName || null,
        storeId: this.dataForm.storeId || null,
        districtName: this.dataForm.districtName || null,
        realName: this.dataForm.realName || null
      }).then(data => {
        if (data && data.code === 0) {
          this.dataList = data.page.list;
          this.totalPage = data.page.totalCount;
        } else {
          this.dataList = [];
          this.totalPage = 0;
          this.$message.error(data.msg);
        }
        this.dataListLoading = false;
      });
    },
    // 区域列表
    getArea() {
     districtList({
        page: 1,
        limit: 1000,
      }).then(data => {
        if (data && data.code === 0) {
          this.areaList = data.page.list;
        } else {
          this.areaList = [];
          this.$message.error(data.msg);
        }
      });
    },
    // 店铺列表
    getStore() {
      storeListData({
          page: 1,
          limit: 10000,
          districtId: null,
       
      }).then(data=> {
        if (data && data.code === 0) {
          this.storeList = data.page.list;
        } else {
          this.storeList = [];
          this.$message.error(data.msg);
        }
      });
    },
    // 返回组长
    getLeader(value) {
      if(value.users){
        let leader = ''
        value.users.forEach(item => {
          if(item.isLeader == 'Y'){
            leader += ' ' + item.realName
          }
        })
        return leader;
      }
    },
    // 根据区域id获取name
    selectItme(event) {
      this.areaList.forEach(item => {
        if(item.districtId == event){
          this.dataForm.districtName = item.districtName;
        }
      })
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    // 重置
    cleaList() {
      this.dataForm = {};
      this.pageIndex = 1;
      this.getDataList();
    },
    // 新增 / 修改
    addOrUpdateHandle(id) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id);
      });
    },
    // 删除
    deleteHandle(id) {
      var userIds = id
        ? [id]
        : this.dataListSelections.map((item) => {
            return item.userId;
          });
      this.$confirm(
        `确定对[id=${userIds.join(",")}]进行[${id ? "删除" : "批量删除"}]操作?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.$http({
            url: this.$http.adornUrl("/zxnl/sys/team/update"),
            method: "post",
            data: this.$http.adornData(userIds, false),
          }).then(({ data }) => {
            if (data && data.code === 0) {
              this.$message({
                message: "操作成功",
                type: "success",
                duration: 500,
                onClose: () => {
                  this.getDataList();
                },
              });
            } else {
              this.$message.error(data.msg);
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.addBtn {
  margin-bottom: 20px;
}
.el-table .cell{
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden; 
}
.el-table .cell:hover{
  height: auto;
  white-space: normal;
  cursor: pointer;
}
</style>